import { infinitySymbol } from '@bestseller/retail-planning.styletimeline';
import { ColDef, ValueGetterParams } from 'ag-grid-community';
import { useMemo } from 'react';
import { useStyleCategoriesQuery } from 'src/hooks/style-categories/queries/useStyleCategoriesQuery';
import { useProductLineGroupsApiQuery } from 'src/hooks/useProductLineGroupsApiQuery';
import { useBusinessModelGroupsApiQuery } from '../queries/useBusinessModelGroupsApiQuery';
import { useBusinessModelsApiQuery } from '../queries/useBusinessModelsApiQuery';
import { useStorefrontTypesApiQuery } from '../queries/useStorefrontTypesApiQuery';
import { useSubStyleCategoriesApiQuery } from '../queries/useSubStyleCategoriesApiQuery';

export const useStyleTimelineSettingsColumns = () => {
    const { data: styleCategories } = useStyleCategoriesQuery();
    const { data: styleSubCategoryData } = useSubStyleCategoriesApiQuery();
    const { data: productLineGroupsData } = useProductLineGroupsApiQuery();
    const { data: businessModelsData } = useBusinessModelsApiQuery();
    const { data: businessModelGroupsData } = useBusinessModelGroupsApiQuery();
    const { data: storefrontTypesData } = useStorefrontTypesApiQuery();

    const columns: ColDef[] = useMemo(
        () => [
            { field: 'priority', headerName: 'Priority', rowDrag: true },
            {
                field: 'storefrontTypeId',
                headerName: 'Storefront type',
                valueGetter: (params: ValueGetterParams) =>
                    storefrontTypesData?.find((x) => x.id === params.data.storefrontTypeId)?.name ?? 'All',
            },
            {
                field: 'styleCategoryId',
                headerName: 'Style category',
                valueGetter: (params: ValueGetterParams) =>
                    styleCategories?.find((x) => x.id === params.data.styleCategoryId)?.name ?? 'All',
            },
            {
                field: 'styleSubCategoryId',
                headerName: 'Style sub category',
                valueGetter: (params: ValueGetterParams) =>
                    styleSubCategoryData?.find((x) => x.id === params.data.styleSubCategoryId)?.name ?? 'All',
            },
            {
                field: 'productLineGroupId',
                headerName: 'Product line group',
                valueGetter: (params: ValueGetterParams) =>
                    productLineGroupsData?.find((x) => x.id === params.data.productLineGroupId)?.name ?? 'All',
            },
            {
                field: 'lifeSpanWeeks',
                headerName: 'Default lifespan',
                valueGetter: (params: ValueGetterParams) =>
                    params.data.lifeSpanWeeks < 0 ? infinitySymbol : `${params.data.lifeSpanWeeks} weeks`,
            },
            {
                field: 'businessModelId',
                headerName: 'Business model',
                valueGetter: (params: ValueGetterParams) =>
                    businessModelsData?.find((x) => x.id === params.data.businessModelId)?.name ?? 'All',
            },
            {
                field: 'businessModelGroupId',
                headerName: 'Business model group',
                valueGetter: (params: ValueGetterParams) =>
                    businessModelGroupsData?.find((x) => x.id === params.data.businessModelGroupId)?.name ?? 'All',
            },
        ],
        [
            storefrontTypesData,
            styleCategories,
            styleSubCategoryData,
            productLineGroupsData,
            businessModelsData,
            businessModelGroupsData,
        ]
    );

    return columns;
};
